/**
 * theme/webStyle.ts
 * A few CSS properties exist only on react-native-web and have no entry in
 * React Native's style types. Casting at each call site would scatter
 * `as unknown as TextStyle` through the components, so the casts live here
 * once, named for what they do.
 */
import { Platform, type TextStyle, type ViewStyle } from 'react-native';

/**
 * Suppress the browser's default focus ring. This design signals focus by
 * darkening the field's border to ink; a ring on top of that would be the only
 * glow on the page. Native has no outline, so this is a no-op there.
 */
export const noFocusOutline: TextStyle = Platform.select({
  web: { outlineStyle: 'none' } as unknown as TextStyle,
  default: {},
}) as TextStyle;

/** `cursor: pointer` on a web pressable that is not a native button element. */
export const pointerCursor: ViewStyle = Platform.select({
  web: { cursor: 'pointer' } as unknown as ViewStyle,
  default: {},
}) as ViewStyle;

/** `cursor: default` — rows that look clickable but are not (decided approvals). */
export const defaultCursor: ViewStyle = Platform.select({
  web: { cursor: 'default' } as unknown as ViewStyle,
  default: {},
}) as ViewStyle;

/**
 * Truncate to one line with an ellipsis on web. On native the same effect
 * comes from `numberOfLines={1}` on the Text itself.
 */
export const ellipsisStyle: TextStyle = Platform.select({
  web: { textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' } as unknown as TextStyle,
  default: {},
}) as TextStyle;
